---
nb:
  email:
    body:
      task_assigned: En ny oppgave relatert til %{power_plant} (%{company}) har blitt tildelt deg.
      yield_loss: 'Avkastningstap:'
    data_export_error:
      body: Din dataeksportforespørsel kunne ikke fullføres fordi valutakursdata mangler for den valgte perioden og valutaen.
      contact_support: Vennligst kontakt support for hjelp.
      error_details: 'Feildetaljer: %{message}'
      greeting: Hei %{name},
    footer:
      auto_generated: Denne e-posten ble automatisk generert
      here: her
      kaiasolutions_staff: Portalen personale
      notifications: Mer informasjon finner du på %{portal_href}.
      notifications_plain: Du mottar denne varslingen fordi du har tilgang til %{brand}.
      portal_href: Portalen sitt operatørdashboard
      regards: Hilsen
    heading:
      greeting: Hei
    subjects:
      data_export_error: Dataeksport mislyktes
      immediate_notifications: Portal - umiddelbare varslinger
      periodic_notifications: Portal - varslinger for %{date}
      task_assigned: Oppgave tildelt
